import { render, staticRenderFns } from "./DragUpload.vue?vue&type=template&id=368e9c85&scoped=true&"
import script from "./DragUpload.vue?vue&type=script&lang=js&"
export * from "./DragUpload.vue?vue&type=script&lang=js&"
import style0 from "./DragUpload.vue?vue&type=style&index=0&id=368e9c85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e9c85",
  null
  
)

component.options.__file = "DragUpload.vue"
export default component.exports